// extracted by mini-css-extract-plugin
export default {"loading":"LoadingBlock_loading__CQ9HQ","background-gradient":"LoadingBlock_background-gradient__CviqN"};